import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface TaxPlay {
  key: string;
  category: string;
  title: string;
  summary: string;
  mechanic: string;
  eligibility: string[];
  estimatedDollarImpact: number | null;
  estimatedImpactBasis: string | null;
  actionLabel: string;
  actionRoute: string;
  authorityUrl: string;
  requiresEntityType: string | null;
  isApplicable: boolean;
  disqualification: string | null;
}

export interface TaxPlaysResponse {
  plays: TaxPlay[];
  projection: {
    taxYear: number;
    hasBlockingGaps: boolean;
    nextDollarBlendedRate: number | null;
    missingInputs: Array<{
      fieldKey: string;
      label: string;
      why: string;
      isBlocking: boolean;
      routeHint: string | null;
    }>;
  };
}

export function useTaxPlays() {
  return useQuery({
    queryKey: ["tax-plays"],
    queryFn: async (): Promise<TaxPlaysResponse> => {
      const r = await api().get<TaxPlaysResponse>("/api/tax-plays");
      return r.data;
    },
  });
}
